import React from 'react';
import PropTypes from 'prop-types';
import { Controls } from './styles/index';

export default class NavButton extends React.Component {
    constructor(props) {
        super(props);
        this.clickHandler = this.clickHandler.bind(this);
    }

    clickHandler() {
        this.props.moveCarousel(this.props.direction);
    }

    render() {
        const items = React.Children.map(this.props.children, child =>
            React.cloneElement(child, {
                onClick: this.clickHandler
            })
        );

        return <Controls direction={this.props.direction}>{items}</Controls>;
    }
}

NavButton.propTypes = {
    moveCarousel: PropTypes.func,
    direction: PropTypes.string.isRequired,
    children: PropTypes.element.isRequired
};

NavButton.defaultProps = {
    moveCarousel: f => f
};
